import CorporateMarketChartContext, {
  useCorporateMarketChartContext,
} from '@/creditflowresearch/application/MarketChart/CorporateMarketChartContext';
import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import { MarketChart } from '@/creditflowresearch/ui/common/components/MarketChart';

const CorporateMarketChart = ({ className }: { className?: string }) => {
  const { chartData } = useParentPageContext();
  return (
    <CorporateMarketChartContext chartData={ chartData }>
      <MarketChart contextHook={ useCorporateMarketChartContext } className={ className } />
    </CorporateMarketChartContext>
  );
};

export default CorporateMarketChart;
